import "../../styles/content.css";
import { BasePage } from './Base';


export function CVPage(props) {
  return (
    <BasePage pageHeader="Curriculum Vitae">
    </BasePage>
  );
}